import { render, staticRenderFns } from "./prestador.vue?vue&type=template&id=48024ba2"
import script from "./prestador.vue?vue&type=script&lang=js"
export * from "./prestador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports